import * as e from 'react';
import { forwardRef, memo } from 'react';

var f=({title:r,titleId:t,...o},l)=>e.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fill:"currentColor",ref:l,"aria-labelledby":t,...o},r?e.createElement("title",{id:t},r):null,e.createElement("path",{d:"M14 14H2V7h1v6h10V7h1Zm-5.5-2h-1V3h1Z"}),e.createElement("path",{d:"M10.29 5.71 11 5 8 2l-.71.71L5 5l.71.71L8 3.42z"})),i=forwardRef(f),m=memo(i),S=m;

export { S as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-FCD3NG5A.mjs.map